<template>
    <el-button 
        :type="type" 
        :size="size"
        :disabled="disabled"
        @click="handleRoute">
        <slot></slot>
    </el-button>
</template>
<script>
    /**
     * 基于element-ui的Button封装，将需要参数配置封装
     * @author wxf
     * @time 2017-09-18
     * @update zjs 2017-09-20
     * @param size 【description: 尺寸,large,small,mini】
     * @param type 【description: 类型，primary,success,warning,danger,info,text】
     * @param disabled 【description: 是否禁用状态】
     * @param route 【description: 路由name】
     * 
     */
    export default {
        name: 'LyRouterButton',
        props: {
            size: {
                type: String,
                default: 'small'
            },
            type: {
                type: String,
                default: 'info'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            route: {
                type: String,
                default: ''
            }
        },
        methods: {
            /**
             * 路由跳转 传入了route参数就跳转到 名为 ‘route’ 的路由 否则返回上一历史 
             */
            handleRoute () {            
                if (Object.is(this.route, null) || Object.is(this.route, '')) { // 判断route参数是否为空
                    this.$router.go(-1)                    
                } else {
                    this.$router.push({path: this.route})
                }
            }
        },
    }
</script>